import { Injectable } from '@angular/core';
//import { Headers, Http } from '@angular/http';
import { FlashMessagesService } from 'angular2-flash-messages';

import 'rxjs/add/operator/toPromise';

import { URL_API } from './../constante';
import { HEADERS } from './../constante';

import { Dados } from './dados';

import { Observable, Subscription } from 'rxjs/Rx';
import { Http, Response, Headers, RequestOptions, RequestMethod, RequestOptionsArgs, URLSearchParams, ResponseContentType } from '@angular/http';
import { Subject } from 'rxjs/Rx';

@Injectable()
export class RelatorioService {
  private options = new RequestOptions(
       { headers: new Headers({ 'Accept': 'application/vnd.ms-excel' }), responseType: ResponseContentType.Blob });

  private relatorioUrl = URL_API + '/relatorio';

  getDados(dados:Dados) {
    let url: string = this.relatorioUrl;

    return this.http.post(url,JSON.stringify(dados),this.options)
      .toPromise()
      .then((data)=>{
          //console.log(data);
          var mediaType = 'application/vnd.ms-excel';
          var blob = new Blob([data.blob()], {type: mediaType});
          //console.log('blob => ' + blob);

          let filename = 'relatorioCDHFM.xls';
          if (navigator.msSaveBlob)
          {
              // IE 10+
              navigator.msSaveBlob(blob, filename);
          }
          else
          {
              var link = document.createElement("a");

              // Browsers com suporte ao atributo download do HTML 5
              if (link.download !== undefined)
              {
                  var url = URL.createObjectURL(blob);
                  link.setAttribute("href", url);
                  link.setAttribute("download", filename);
                  link.style.visibility = 'hidden';
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
              }
          }
      })
      .catch(error => {console.log(error);alert("ERRO AO GERAR O ARQUIVO XLS! TENTE NOVAMENTE!");});
  }

  constructor(
    private http: Http,
    private _flashMessagesService: FlashMessagesService,
  ) {}

  private handleSuccess(resp: any): Promise<any> {
    this._flashMessagesService.show(resp, { cssClass: 'alert-success', timeout: 30000 });
    return resp;
  }

  private handleError(error: any): Promise<any> {
    console.log(error)
    switch (error.status) {
      case 500:
        this._flashMessagesService.show("Ocorreu erro no servidor, entre em contato com o administrador.", { cssClass: 'alert-danger', timeout: 15000 });
        break;
      case 403:
        this._flashMessagesService.show(error.json().msg, { cssClass: 'alert-warning', timeout: 25000 });
        break;
      default:
        this._flashMessagesService.show("Ocorreu um erro, tente novamente mais tarde.", { cssClass: 'alert-danger', timeout: 15000 });

    }
    return Promise.reject(error.message || error);
  }

}



// WEBPACK FOOTER //
// ./src/app/relatorios/relatorio.service.ts